import {
  Component,
  EventEmitter,
  OnInit,
  ViewChild,
  Output
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { functonLabel, ICustomer, IMachineForSettings, IMachineForSettingsView } from 'app/models';
import { MachineService, CustomerService } from 'app/services';
import { MessageService } from 'app/services/message/message.service';

import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from '../confirm-dialog/confirm-dialog.component';

import { MachineMngtDetailComponent } from '../machine-mngt-detail/machine-mngt-detail.component';
import { AbstractSettingsFilteredTableComponent } from '../setting-mngt-filtered-table';
import {
  ViewImgDialogComponent,
  ViewImgDialogModel,
} from '../view-img-dialog/view-img-dialog.component';

@Component({
  selector: 'app-machine-mngt',
  templateUrl: './machine-mngt.component.html',
  styleUrls: ['./machine-mngt.component.scss'],
})
export class MachineMngtComponent extends AbstractSettingsFilteredTableComponent<IMachineForSettingsView> implements OnInit {

  @Output()
  machinesAddedOrUpdated = new EventEmitter<boolean>();

  @ViewChild(MachineMngtDetailComponent)
  private machineMngtDetailComponent!: MachineMngtDetailComponent;

  customers: ICustomer[] = [];
  readonly functonLabel = functonLabel;

  readonly displayedColumns = [
    'serialNumber',
    'name',
    'customer',
    'function',
    'operator',
    'year',
    'machineType',
    'hasImage',
    'Actions',
  ];

  dataSource = new MatTableDataSource<IMachineForSettingsView>();

  constructor(
    private machineService: MachineService,
    private customerService: CustomerService,
    public dialog: MatDialog,
    private messageService: MessageService
  ) {
    super();
  }

  ngOnInit() {
    this.getCustomers();
    this.getMachines();
  }

  onMachineSaved(saved: boolean) {
    const msg: string = saved
      ? ` Machine correctly saved `
      : ` Machine NOT correctly saved `;
    this.messageService.showDirectSimpleMessage(msg);
    this.getMachines();
    this.machinesAddedOrUpdated.emit();
  }

  getMachines(): void {
    this.machineService.findAllMachinesForSettings().subscribe(
      (machines) => {
        const viewMachines: IMachineForSettingsView[] = machines.map(
          currentMachine => {
            (currentMachine as IMachineForSettingsView).customerName = this.getCustomerById(currentMachine.customerId)?.name;
            (currentMachine as IMachineForSettingsView).functionName = this.functonLabel[currentMachine.function];
            return currentMachine;
          }
        );
        this.dataSource.data = viewMachines;
      },
      () =>
        this.messageService.showDirectSimpleMessage(` Loading machines error `)
    );
  }

  getCustomers(): void {
    this.customerService.findAllCustomers().subscribe(
      (customers) => (this.customers = customers.sort((a, b) => (a.name < b.name) ? -1 : 1)),
      () =>
        this.messageService.showDirectSimpleMessage(` Loading customers error `)
    );
  }

  getCustomerById(id: number): ICustomer | undefined {
    return this.customers.find((item) => item.id === id);
  }

  deleteConfirmDialog(machineToBeDeleted: IMachineForSettings): void {
    const message = `Are you sure you want to delete the machine with serialNumber ${machineToBeDeleted.serialNumber} ?
          you have to delete associated agents before `;
    const dialogData = new ConfirmDialogModel('Confirm Delete Action', message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        if (machineToBeDeleted.id) {
          this.machineService.deleteMachine(machineToBeDeleted.id).subscribe(
            () =>
              this.messageService.showDirectSimpleMessage(` Machine deleted `),
            () =>
              this.messageService.showDirectSimpleMessage(
                ` Machine delete error `
              ),
            () => {
              this.getMachines();
              this.machinesAddedOrUpdated.emit();
            }
          );
        }
      }
    });
  }

  edit(machine: IMachineForSettings): void {
    this.machineMngtDetailComponent.initEdit(machine);
  }

  viewImgDialog(machineId: number): void {
    this.machineService.findMachineById(machineId).subscribe(
      (res) => {
        if (res.imageStr) {
          const dialogData = new ViewImgDialogModel(res.imageStr);
          this.dialog.open(ViewImgDialogComponent, {
            data: dialogData,
          });
        }
      },
      () => this.messageService.showDirectSimpleMessage(` img load error `)
    );
  }

}
